import axios from "axios";
import React, { useEffect, useState } from "react";
import Collapsible from "react-collapsible";
import { Config } from "../../../../../../Config";
import EyeIcon from "../../../../../../Assets/Images/JPA Icons/eye.svg";
import Meh from "../../../../../../Assets/Images/JPA Icons/meh.svg";
import MehSilver from "../../../../../../Assets/Images/JPA Icons/meh-silver.svg";
import MessageIcon from "../../../../../../Assets/Images/JPA Icons/message-circle.svg";
import MessageWhite from "../../../../../../Assets/Images/JPA Icons/message-circle-white.svg";
import Smile from "../../../../../../Assets/Images/JPA Icons/smile.svg";
import SmileWhite from "../../../../../../Assets/Images/JPA Icons/smile-white.svg";
import Frown from "../../../../../../Assets/Images/JPA Icons/frown.svg";
import Anonymous from "../../../../../../Assets/Images/JPA Icons/anonymous.svg";
import AnonymousWhite from "../../../../../../Assets/Images/JPA Icons/anonymous-white.svg";
import { NavLink } from "react-router-dom";
import { formatDate } from "../../../../../../Helper_functions";
import ReasonPopup from "./ReasonPopup";
import AvalilabilityDatepicker from "../../../ShareElements/AvailabilityDatepicker/AvailabilityDatepicker";
import AvailabilityIconSilver from "../../../../../../Assets/Images/more-time.svg";
import ConnectIcon from "../../../../../../Assets/Images/Communication.svg";
import BookmarkIcon from "../../../../../../Assets/Images/bookmark-plus.svg";
import BookmarkedIcon from "../../../../../../Assets/Images/Bookmarked-item.svg";

const JPAItem = (props) => {
  const [ItemDetails, setItemDetails] = useState();
  const [IsSaved, setIsSaved] = useState(false);
  const [HasBeenRejected, setHasBeenRejected] = useState(false);
  const [HasCoolcown, setHasCooldown] = useState(false);
  const [PopupIsOpen, setPopupIsOpen] = useState(false);
  const [Reasons, setReasons] = useState([]);
  const [LastJPAaction, setLastJPAaction] = useState("like");
  const [IsLiked, setIsLiked] = useState(false);
  const [IsDisliked, setIsDisliked] = useState(false);
  const [AvailabilityDatePickerIsOpen, setAvailabilityDatePickerIsOpen] =
    useState(false);
  const [AvailabilityCollapsibleIsOpen, setAvailabilityCollapsibleIsOpen] =
    useState(false);
  const [ApplicationData, setApplicationData] = useState();
  const [SelectedStartDate, setSelectedStartDate] = useState();
  const [SelectedEndDate, setSelectedEndDate] = useState();
  const [ContextMenuIsOpen, setContextMenuIsOpen] = useState(false);

  useEffect(() => {
    props.Data.bookmarked ? setIsSaved(true) : setIsSaved(false);
    if (props.Type === "Job") {
      setItemDetails(props.Data.position);
    } else if (props.Type === "Project") {
      setItemDetails(props.Data.project);
    } else {
      setItemDetails(props.Data.activity);
    }
    checkRejectionStatus();
    createReactionsData();

    // Initial setting of like and dislike reaction booleans in the state
    if (props.Data.reactionType === "DISLIKE") {
      setIsDisliked(true);
    }
    if (props.Data.reactionType === "LIKE") {
      setIsLiked(true);
    }
  }, []);

  const createReactionsData = () => {
    let List = [];
    [...props.ReactionReasons].map((Item) => {
      let ItemToPush = {
        name: Item.reasonName, // is the label id related to that text
        id: Item.id,
        selected: false,
      };
      if (
        props.Data.reactionReasons &&
        props.Data.reactionReasons.includes(Item.id)
      ) {
        ItemToPush.selected = true;
      }
      List.push(ItemToPush);
    });
    setReasons(List);
  };

  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    if (LabelId === "responsiblity") {
      Keyword = "responsibility";
    }
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    if (Label[0] === undefined) {
      console.log(LabelId);
    } else {
      return Label[0].label_value;
    }
  };

  const handleOpen = () => {
    document.getElementById(props.Id + "-icon").classList.add("rotated");
  };
  const handleClose = () => {
    document.getElementById(props.Id + "-icon").classList.remove("rotated");
  };
  const checkRejectionStatus = () => {
    if (
      props.ApplicationData === null ||
      props.ApplicationData.lastRejectionTime === null
    ) {
      setHasBeenRejected(false);
    } else {
      setHasBeenRejected(true);
      let RejectionDate = props.ApplicationData.lastRejectionTime;
      let RejectionMilliSeconds = new Date(RejectionDate).getTime();
      let Now = new Date().getTime();
      //each day is 86400000 milliseconds, 6 months time is 15552000000 milliseconds (180 days)
      let Difference = Now - RejectionMilliSeconds;
      if (Difference < 15552000000) {
        setHasCooldown(true);
      } else {
        setHasCooldown(false);
      }
    }
  };
  const toggleLike = (WillRepeat) => {
    setLastJPAaction("like");

    if (LastJPAaction === "dislike") {
      clearSelectedReasons();
    }

    if (props.MoreLikeThisIsActive) {
      likeMoreLikeThisItem(WillRepeat);
    } else {
      likeRecommendation(WillRepeat);
    }
  };

  const selectPreviousReasons = (PreviouslySelectedReasonIDs) => {
    let NewReasonsList = [];
    [...Reasons].map((Reason) => {
      if (PreviouslySelectedReasonIDs.includes(Reason.id)) {
        Reason.selected = true;
      }
      NewReasonsList.push(Reason);
    });
    setReasons(NewReasonsList);
  };

  const likeMoreLikeThisItem = (WillRepeat) => {
    let ActionURL;
    let ActionType;
    let Data = {
      reactionType: "LIKE",
    };

    if (props.Type === "Project") {
      ActionURL = Config.ProjectServiceURL;
      ActionType = props.Type.toLowerCase();
      Data.id = props.Data.id;
    } else if (props.Type === "Activity") {
      ActionURL = Config.ActivityServiceURL;
      ActionType = props.Type.toLowerCase();
      Data.id = props.Data.id;
    } else {
      ActionURL = Config.PositionServiceURL;
      ActionType = "position";
      Data.id = props.Data.id;
    }

    if (
      document
        .getElementById(props.Id + "-like")
        .classList.contains("overlayed-no-animation") &&
      !WillRepeat
    ) {
      Data.reactionType = null;
    }

    let SelectedReasons = [];
    Reasons.map((Reason) => {
      if (Reason.selected) {
        SelectedReasons.push(Reason.id);
      }
    });
    if (SelectedReasons.length > 0) {
      Data.reactionReasons = SelectedReasons;
    }

    if (!WillRepeat) {
      if (
        document
          .getElementById(props.Id + "-like")
          .classList.contains("overlayed-no-animation") ||
        document
          .getElementById(props.Id + "-like")
          .classList.contains("overlayed")
      ) {
        document
          .getElementById(props.Id + "-like")
          .classList.remove("overlayed", "overlayed-no-animation");
      } else {
        document
          .getElementById(props.Id + "-dislike")
          .classList.remove("overlayed", "overlayed-no-animation");
        document
          .getElementById(props.Id + "-like")
          .classList.add("overlayed", "overlayed-no-animation");
      }
    }

    if (
      document
        .getElementById(props.Id + "-like")
        .classList.contains("overlayed-no-animation") ||
      document
        .getElementById(props.Id + "-like")
        .classList.contains("overlayed")
    ) {
      setPopupIsOpen(true);
    }

    let Req = {
      method: "POST",
      baseURL:
        window._env_.API_URL +
        ActionURL +
        "/api/" +
        ActionType +
        "/recommendation/similar/reaction",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "application/json",
      },
      data: Data,
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        // setting the liked state to differentiate between liked and unliked state
        if (Res.data.reactionType === "LIKE") {
          setIsLiked(true);
          selectPreviousReasons(Res.data.reactionReasons);
        } else {
          setIsLiked(false);
          setPopupIsOpen(false);
        }
        const jpaType =
          props.Type.toLowerCase() === "job"
            ? "position"
            : props.Type.toLowerCase();
        props.RefreshRecentItems(
          Res.data[jpaType]?.id,
          Res.data.reactionType,
          Res.data.bookmarked
        );
      })
      .catch((Err) => {
        console.log(Err.response);
      });
  };

  const likeRecommendation = (WillRepeat) => {
    let ActionURL;
    let ActionType;
    let Data = {
      reactionType: "LIKE",
    };

    if (props.Type === "Project") {
      ActionURL = Config.ProjectServiceURL;
      ActionType = props.Type.toLowerCase();
      Data.projectRecommendationId = props.Data.id;
    } else if (props.Type === "Activity") {
      ActionURL = Config.ActivityServiceURL;
      ActionType = props.Type.toLowerCase();
      Data.activityRecommendationId = props.Data.id;
    } else {
      ActionURL = Config.PositionServiceURL;
      ActionType = "position";
      Data.positionRecommendationId = props.Data.id;
    }

    if (
      document
        .getElementById(props.Id + "-like")
        .classList.contains("overlayed-no-animation") &&
      !WillRepeat
    ) {
      Data.reactionType = null;
    }

    let SelectedReasons = [];
    Reasons.map((Reason) => {
      if (Reason.selected) {
        SelectedReasons.push(Reason.id);
      }
    });
    if (SelectedReasons.length > 0) {
      Data.reactionReasons = SelectedReasons;
    }

    if (!WillRepeat) {
      if (
        document
          .getElementById(props.Id + "-like")
          .classList.contains("overlayed-no-animation") ||
        document
          .getElementById(props.Id + "-like")
          .classList.contains("overlayed")
      ) {
        document
          .getElementById(props.Id + "-like")
          .classList.remove("overlayed", "overlayed-no-animation");
      } else {
        document
          .getElementById(props.Id + "-dislike")
          .classList.remove("overlayed", "overlayed-no-animation");
        document
          .getElementById(props.Id + "-like")
          .classList.add("overlayed", "overlayed-no-animation");
      }
    }

    if (
      document
        .getElementById(props.Id + "-like")
        .classList.contains("overlayed-no-animation") ||
      document
        .getElementById(props.Id + "-like")
        .classList.contains("overlayed")
    ) {
      setPopupIsOpen(true);
    }

    let Req = {
      method: "POST",
      baseURL:
        window._env_.API_URL +
        ActionURL +
        "/api/" +
        ActionType +
        "/recommendation/reaction",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "application/json",
      },
      data: Data,
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        // setting the liked state to differentiate between liked and unliked state
        if (Res.data.reactionType === "LIKE") {
          setIsLiked(true);
          selectPreviousReasons(Res.data.reactionReasons);
        } else {
          setIsLiked(false);
          setPopupIsOpen(false);
        }
        const jpaType =
          props.Type.toLowerCase() === "job"
            ? "position"
            : props.Type.toLowerCase();
        props.RefreshRecentItems(
          Res.data[jpaType]?.id,
          Res.data.reactionType,
          Res.data.bookmarked
        );
      })
      .catch((Err) => {
        console.log(Err.response);
      });
  };
  const toggleDislike = (WillRepeat) => {
    setLastJPAaction("dislike");

    if (LastJPAaction === "like") {
      clearSelectedReasons();
    }

    if (props.MoreLikeThisIsActive) {
      dislikeMoreLikeThisItem(WillRepeat);
    } else {
      dislikeRecommendation(WillRepeat);
    }
  };

  const clearSelectedReasons = () => {
    let NewList = [];
    Reasons.map((Item) => {
      NewList.push({
        name: Item.name,
        id: Item.id,
        selected: false,
      });
    });
    setReasons(NewList);
  };

  const dislikeMoreLikeThisItem = (WillRepeat) => {
    let ActionURL;
    let ActionType;
    let Data = {
      reactionType: "DISLIKE",
    };

    if (props.Type === "Project") {
      ActionURL = Config.ProjectServiceURL;
      ActionType = props.Type.toLowerCase();
      Data.id = props.Data.id;
    } else if (props.Type === "Activity") {
      ActionURL = Config.ActivityServiceURL;
      ActionType = props.Type.toLowerCase();
      Data.id = props.Data.id;
    } else {
      ActionURL = Config.PositionServiceURL;
      ActionType = "position";
      Data.id = props.Data.id;
    }

    if (
      document
        .getElementById(props.Id + "-dislike")
        .classList.contains("overlayed-no-animation") &&
      !WillRepeat
    ) {
      Data.reactionType = null;
    }

    let SelectedReasons = [];
    Reasons.map((Reason) => {
      if (Reason.selected) {
        SelectedReasons.push(Reason.id);
      }
    });
    if (SelectedReasons.length > 0) {
      Data.reactionReasons = SelectedReasons;
    }

    if (!WillRepeat) {
      if (
        document
          .getElementById(props.Id + "-dislike")
          .classList.contains("overlayed-no-animation") ||
        document
          .getElementById(props.Id + "-dislike")
          .classList.contains("overlayed")
      ) {
        document
          .getElementById(props.Id + "-dislike")
          .classList.remove("overlayed", "overlayed-no-animation");
      } else {
        document
          .getElementById(props.Id + "-dislike")
          .classList.add("overlayed", "overlayed-no-animation");
        document
          .getElementById(props.Id + "-like")
          .classList.remove("overlayed", "overlayed-no-animation");
      }
    }

    if (
      document
        .getElementById(props.Id + "-dislike")
        .classList.contains("overlayed-no-animation") ||
      document
        .getElementById(props.Id + "-dislike")
        .classList.contains("overlayed")
    ) {
      setPopupIsOpen(true);
    }

    let Req = {
      method: "POST",
      baseURL:
        window._env_.API_URL +
        ActionURL +
        "/api/" +
        ActionType +
        "/recommendation/similar/reaction",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "application/json",
      },
      data: Data,
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        // setting the liked state to differentiate between disliked and undisliked state
        if (Res.data.reactionType === "DISLIKE") {
          setIsDisliked(true);
          selectPreviousReasons(Res.data.reactionReasons);
        } else {
          setIsDisliked(false);
          setPopupIsOpen(false);
        }

        const jpaType =
          props.Type.toLowerCase() === "job"
            ? "position"
            : props.Type.toLowerCase();
        props.RefreshRecentItems(
          Res.data[jpaType]?.id,
          Res.data.reactionType,
          Res.data.bookmarked
        );
      })
      .catch((Err) => {
        console.log(Err.response);
      });
  };
  const dislikeRecommendation = (WillRepeat) => {
    let ActionURL;
    let ActionType;
    let Data = {
      reactionType: "DISLIKE",
    };

    if (props.Type === "Project") {
      ActionURL = Config.ProjectServiceURL;
      ActionType = props.Type.toLowerCase();
      Data.projectRecommendationId = props.Data.id;
    } else if (props.Type === "Activity") {
      ActionURL = Config.ActivityServiceURL;
      ActionType = props.Type.toLowerCase();
      Data.activityRecommendationId = props.Data.id;
    } else {
      ActionURL = Config.PositionServiceURL;
      ActionType = "position";
      Data.positionRecommendationId = props.Data.id;
    }

    if (
      document
        .getElementById(props.Id + "-dislike")
        .classList.contains("overlayed-no-animation") &&
      !WillRepeat
    ) {
      Data.reactionType = null;
    }

    let SelectedReasons = [];
    Reasons.map((Reason) => {
      if (Reason.selected) {
        SelectedReasons.push(Reason.id);
      }
    });
    if (SelectedReasons.length > 0) {
      Data.reactionReasons = SelectedReasons;
    }

    if (!WillRepeat) {
      if (
        document
          .getElementById(props.Id + "-dislike")
          .classList.contains("overlayed-no-animation") ||
        document
          .getElementById(props.Id + "-dislike")
          .classList.contains("overlayed")
      ) {
        document
          .getElementById(props.Id + "-dislike")
          .classList.remove("overlayed", "overlayed-no-animation");
      } else {
        document
          .getElementById(props.Id + "-dislike")
          .classList.add("overlayed", "overlayed-no-animation");
        document
          .getElementById(props.Id + "-like")
          .classList.remove("overlayed", "overlayed-no-animation");
      }
    }

    if (
      document
        .getElementById(props.Id + "-dislike")
        .classList.contains("overlayed-no-animation") ||
      document
        .getElementById(props.Id + "-dislike")
        .classList.contains("overlayed")
    ) {
      setPopupIsOpen(true);
    }

    let Req = {
      method: "POST",
      baseURL:
        window._env_.API_URL +
        ActionURL +
        "/api/" +
        ActionType +
        "/recommendation/reaction",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "application/json",
      },
      data: Data,
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        // setting the liked state to differentiate between disliked and undisliked state
        if (Res.data.reactionType === "DISLIKE") {
          setIsDisliked(true);
          selectPreviousReasons(Res.data.reactionReasons);
        } else {
          setIsDisliked(false);
          setPopupIsOpen(false);
        }
        const jpaType =
          props.Type.toLowerCase() === "job"
            ? "position"
            : props.Type.toLowerCase();
        props.RefreshRecentItems(
          Res.data[jpaType]?.id,
          Res.data.reactionType,
          Res.data.bookmarked
        );
      })
      .catch((Err) => {
        console.log(Err.response);
      });
  };
  const toggleSave = () => {
    if (props.MoreLikeThisIsActive) {
      saveMoreLikeThisItem();
    } else {
      saveRecommendedItem();
    }
  };

  const saveMoreLikeThisItem = () => {
    let ActionURL;
    let ActionType;
    let Data = {};
    if (props.Type === "Project") {
      ActionURL = Config.ProjectServiceURL;
      ActionType = props.Type.toLowerCase();
      Data.id = props.Data.id;
    } else if (props.Type === "Activity") {
      ActionURL = Config.ActivityServiceURL;
      ActionType = props.Type.toLowerCase();
      Data.id = props.Data.id;
    } else {
      ActionURL = Config.PositionServiceURL;
      ActionType = "position";
      Data.id = props.Data.id;
    }

    if (
      document.getElementById(props.Id + "-save").classList.contains("saved") ||
      document
        .getElementById(props.Id + "-save")
        .classList.contains("saved-no-animation")
    ) {
      document
        .getElementById(props.Id + "-save")
        .classList.remove("saved", "saved-no-animation");
    } else {
      document.getElementById(props.Id + "-save").classList.add("saved");
    }

    setIsSaved(!IsSaved);

    let Req = {
      method: "POST",
      baseURL:
        window._env_.API_URL +
        ActionURL +
        "/api/" +
        ActionType +
        "/recommendation/similar/bookmark",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-type": "application/json",
      },
      data: Data,
    };

    axios(Req)
      .then((Res) => {
        console.log(Res);
        props.ClickActivePage();
        const jpaType =
          props.Type.toLowerCase() === "job"
            ? "position"
            : props.Type.toLowerCase();
        props.RefreshRecentItems(
          Res.data[jpaType]?.id,
          Res.data.reactionType,
          Res.data.bookmarked
        );
      })
      .catch((Err) => {
        console.log(Err.response);
      });
  };

  // bookmarks a recommendation and not a "more like this item"
  const saveRecommendedItem = () => {
    let ActionURL;
    let ActionType;
    let Data = {};
    if (props.Type === "Project") {
      ActionURL = Config.ProjectServiceURL;
      ActionType = props.Type.toLowerCase();
      Data.recommendationId = props.Data.id;
    } else if (props.Type === "Activity") {
      ActionURL = Config.ActivityServiceURL;
      ActionType = props.Type.toLowerCase();
      Data.recommendationId = props.Data.id;
    } else {
      ActionURL = Config.PositionServiceURL;
      ActionType = "position";
      Data.positionRecommendationId = props.Data.id;
    }

    if (
      document.getElementById(props.Id + "-save").classList.contains("saved") ||
      document
        .getElementById(props.Id + "-save")
        .classList.contains("saved-no-animation")
    ) {
      document
        .getElementById(props.Id + "-save")
        .classList.remove("saved", "saved-no-animation");
    } else {
      document.getElementById(props.Id + "-save").classList.add("saved");
    }

    setIsSaved(!IsSaved);

    let Req = {
      method: "POST",
      baseURL:
        window._env_.API_URL +
        ActionURL +
        "/api/" +
        ActionType +
        "/recommendation/bookmark",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-type": "application/json",
      },
      data: Data,
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        props.ClickActivePage();
        const jpaType =
          props.Type.toLowerCase() === "job"
            ? "position"
            : props.Type.toLowerCase();
        props.RefreshRecentItems(
          Res.data[jpaType]?.id,
          Res.data.reactionType,
          Res.data.bookmarked
        );
      })
      .catch((Err) => {
        console.log(Err.response);
      });
  };
  const shortenTitle = (Title) => {
    if (window.innerWidth <= 450) {
      if (Title.length < 24) {
        return Title;
      } else {
        return Title.slice(0, 20) + " ...";
      }
    } else if (window.innerWidth > 450 && window.innerWidth < 1450) {
      if (Title.length < 25) {
        return Title;
      } else {
        return Title.slice(0, 21) + " ...";
      }
    } else if (window.innerWidth > 450 && window.innerWidth < 1960) {
      if (Title.length < 35) {
        return Title;
      } else {
        return Title.slice(0, 31) + " ...";
      }
    } else {
      if (Title.length < 39) {
        return Title;
      } else {
        return Title.slice(0, 37) + " ...";
      }
    }
  };
  const handleDisplayPopup = () => {
    if (window.innerWidth <= 450) {
      if (ItemDetails.title.length < 24) {
        return null;
      } else {
        return <p>{ItemDetails.title}</p>;
      }
    } else if (window.innerWidth > 450 && window.innerWidth < 1450) {
      if (ItemDetails.title.length < 25) {
        return null;
      } else {
        return <p>{ItemDetails.title}</p>;
      }
    } else if (window.innerWidth > 450 && window.innerWidth < 1960) {
      if (ItemDetails.title.length < 35) {
        return null;
      } else {
        return <p>{ItemDetails.title}</p>;
      }
    }
  };
  // gets the status field in API response (originnally all in Uppercase) and returns the text
  // with capitalized First alphabet and lowercase for the rest; e.g. : ("APPLIED") => ("Applied")
  const showStatus = (ApplicationData) => {
    if (ApplicationData.status !== "CANCELLED") {
      if (
        ApplicationData.details[0].subStage === "DONE" &&
        ApplicationData.details[1].subStage === "PENDING"
      ) {
        return translateText("jpa_status_applied");
      } else if (
        ApplicationData.details[0].subStage === "DONE" &&
        ApplicationData.details[2].subStage === "PENDING"
      ) {
        return translateText("jpa_status_action_stage_review");
      } else if (
        ApplicationData.details[1].subStage === "IN_PROGRESS" &&
        ApplicationData.details[2].subStage === "PENDING"
      ) {
        return translateText("jpa_status_action_stage_review");
      } else if (ApplicationData.details[2].subStage === "IN_PROGRESS") {
        return translateText("jpa_status_action_interview");
      } else {
        if (ApplicationData.details[3] !== undefined) {
          if (
            (ApplicationData.details[2].subStage === "INVITE_SENT" &&
              props.Data.application.details[0].subStage === "DONE" &&
              props.Data.application.details[1].subStage === "DONE" &&
              props.Data.application.details[2].subStage === "INVITE_SENT" &&
              props.Data.application.details[2].stage === "INTERVIEW" &&
              props.Data.application.details[3].subStage === "PENDING") ||
            props.ApplicationData.details[2].subStage === "INVITE_REJECTED" ||
            props.ApplicationData.details[2].subStage === "INVITE_ACCEPTED"
          ) {
            return translateText("jpa_status_action_interview");
          } else if (
            props.ApplicationData.details[0].subStage === "DONE" &&
            props.ApplicationData.details[1].subStage === "DONE" &&
            props.ApplicationData.details[2].subStage === "SKIPPED" &&
            props.ApplicationData.details[3].stage === "FINAL_DECISION" &&
            props.ApplicationData.details[3].subStage === "CANCELLED"
          ) {
            return translateText("jpa_status_cancelled");
          } else if (
            props.ApplicationData.details[0].subStage === "DONE" &&
            props.ApplicationData.details[1].subStage === "DONE" &&
            props.ApplicationData.details[2].subStage === "CANCELLED" &&
            props.ApplicationData.details[3].stage === "FINAL_DECISION" &&
            props.ApplicationData.details[3].subStage === "CANCELLED"
          ) {
            return translateText("jpa_status_cancelled");
          } else {
            if (props.ApplicationData.details[3].stage === "ACCEPTED") {
              return translateText("jpa_status_accepted");
            } else if (
              props.ApplicationData.details[3].stage === "NOT_ACCEPTED"
            ) {
              return translateText("jpa_status_not_accepted");
            } else {
              return translateText("jpa_action_stage_final_decision");
            }
          }
        }
      }
    } else {
      return translateText("jpa_status_cancelled");
    }
  };
  const shortenLocation = (ItemLocation) => {
    if (ItemLocation !== undefined) {
      if (window.innerWidth <= 450) {
        if (ItemLocation.length < 28) {
          return ItemLocation;
        } else {
          return ItemLocation.slice(0, 24) + " ...";
        }
      } else if (window.innerWidth > 450 && window.innerWidth < 1450) {
        if (ItemLocation.length < 39) {
          return ItemLocation;
        } else {
          return ItemLocation.slice(0, 35) + " ...";
        }
      } else if (window.innerWidth > 450 && window.innerWidth < 1960) {
        if (ItemLocation.length < 49) {
          return ItemLocation;
        } else {
          return ItemLocation.slice(0, 45) + " ...";
        }
      } else {
        if (ItemLocation.length < 49) {
          return ItemLocation;
        } else {
          return ItemLocation.slice(0, 45) + " ...";
        }
      }
    }
  };
  const handleDisplayLocationPopup = () => {
    if (window.innerWidth <= 450) {
      if (ItemDetails.workCity.length < 28) {
        return null;
      } else {
        return <p className="popup-location">{ItemDetails.workCity}</p>;
      }
    } else if (window.innerWidth > 450 && window.innerWidth < 1450) {
      if (ItemDetails.workCity.length < 39) {
        return null;
      } else {
        return <p className="popup-location">{ItemDetails.workCity}</p>;
      }
    } else if (window.innerWidth > 450 && window.innerWidth < 1960) {
      if (ItemDetails.workCity.length < 49) {
        return null;
      } else {
        return <p className="popup-location">{ItemDetails.workCity}</p>;
      }
    }
  };
  const returnCancellationDate = (ApplicationData) => {
    let DateString = new Date(ApplicationData.date);
    return formatDate(DateString);
  };
  const displayReapplyDate = (ApplicationData) => {
    let DateString = new Date(ApplicationData.date).getTime();
    let CurrentTime = new Date().getTime();

    let Duration = parseInt(CurrentTime - DateString);
    var Minutes = Math.floor((Duration / (1000 * 60)) % 60);
    var Hours = Math.floor((Duration / (1000 * 60 * 60)) % 24);
    var Seconds = Math.floor((Duration / 1000) % 60);
    let RemainingHours = parseInt(23 - Hours);
    let RemainingMins = parseInt(59 - Minutes);
    let RemainingSeconds = parseInt(59 - Seconds);
    if (RemainingHours < 10) {
      RemainingHours = "0" + RemainingHours;
    }
    if (RemainingHours > 23) {
      RemainingHours = 23;
    }

    if (RemainingMins < 10) {
      RemainingMins = "0" + RemainingMins;
    }
    if (RemainingMins > 59) {
      RemainingMins = 59;
    }

    if (RemainingSeconds < 10) {
      RemainingSeconds = "0" + RemainingSeconds;
    }
    if (RemainingSeconds > 59) {
      RemainingSeconds = 59;
    }

    return (
      RemainingHours +
      " h " +
      RemainingMins +
      " min and " +
      RemainingSeconds +
      " sec"
    );
  };
  const toggleChat = () => {
    props.SetSelectedJPA(props.Data);
    if (
      props.Data.application !== null &&
      !props.Data.application.revealIdentity &&
      props.Data.application.status !== "CANCELLED"
    ) {
      props.SetVerifyConnectIsOpen(true);
    } else {
      goToChatRoom();
    }
  };

  const goToChatRoom = () => {
    let JPAId = "";
    let JPATitle = "";
    let WorkCity = "";
    let JPAType = "";
    if (props.Type === "Project") {
      JPAId = props.Data.project.id;
      JPATitle = props.Data.project.title;
      WorkCity = props.Data.project.workCity;
      JPAType = "project";
    } else if (props.Type === "Activity") {
      JPAId = props.Data.activity.id;
      JPATitle = props.Data.activity.title;
      WorkCity = props.Data.activity.workCity;
      JPAType = "activity";
    } else {
      JPAId = props.Data.position.id;
      JPATitle = props.Data.position.title;
      WorkCity = props.Data.position.workCity;
      JPAType = "position";
    }
    window.localStorage.setItem("chat_jpaId", JPAId);
    window.localStorage.setItem("chat_recipientId", props.Data.reviewer.id);
    window.localStorage.setItem("chat_title", JPATitle);
    window.localStorage.setItem("chat_workCiy", WorkCity);
    window.localStorage.setItem("chat_jpaType", JPAType);
    window.localStorage.setItem("chat_source", "APPLICATION");
    setTimeout(() => {
      document.getElementById("communication-toggle").click();
    }, 200);
  };
  const showApplicationType = (AppData) => {
    if (AppData.type === "ANONYMOUS") {
      return "(" + translateText("applied_anonymously") + ")";
    } else {
      return "(" + translateText("applied_with_identity") + ")";
    }
  };
  const selectReason = (Reason) => {
    let Index = Reasons.indexOf(Reason);
    let List = [...Reasons];
    if (Reason.selected) {
      List[Index].selected = false;
    } else {
      List[Index].selected = true;
    }
    setReasons(List);
    updateReactionReasons();
  };
  const updateReactionReasons = () => {
    if (LastJPAaction === "like") {
      toggleLike(true);
    } else {
      toggleDislike(true);
    }
  };
  const toggleApplication = (Data, ApplicationType) => {
    setAvailabilityDatePickerIsOpen(true);
    setTimeout(() => {
      document.getElementById(props.Id).click();
    }, 500);

    setApplicationData({ data: Data, type: ApplicationType });
  };
  const handleCloseCollapsible = () => {
    handleClose();
    setAvailabilityCollapsibleIsOpen(false);
  };
  const handleOpenCollapsible = () => {
    handleOpen();
    setAvailabilityCollapsibleIsOpen(true);
  };
  const cancelApplicationRequest = () => {
    setAvailabilityDatePickerIsOpen(false);
    setAvailabilityCollapsibleIsOpen(false);
  };
  const validateAvailabilityValues = () => {
    let NumberValue = document.getElementById("value")?.value;
    let Unit = document.getElementById("avalability-filter")?.value;

    let AvailabilityData = {
      value: NumberValue || null,
      unit: NumberValue ? Unit : null,
      startDate: SelectedStartDate,
      endDate: SelectedEndDate,
    };
    // props.ToggleApply(ApplicationData.data, ApplicationData.type);
    submitApplication(props.Type, ApplicationData.type, AvailabilityData);
  };

  const submitApplication = (Type, Application_Type, AvailabilityData) => {
    let URLparam;
    let ApplicationType;

    if (Type === "Job") {
      if (props.MoreLikeThisIsActive) {
        URLparam =
          Config.PositionServiceURL +
          "/api/position/recommendation/similar/application";
      } else {
        URLparam = Config.PositionServiceURL + "/api/position/application";
      }
    } else if (Type === "Project") {
      if (props.MoreLikeThisIsActive) {
        URLparam =
          Config.ProjectServiceURL +
          "/api/project/recommendation/similar/application";
      } else {
        URLparam = Config.ProjectServiceURL + "/api/project/application";
      }
    } else if (Type === "Activity") {
      if (props.MoreLikeThisIsActive) {
        URLparam =
          Config.ActivityServiceURL +
          "/api/activity/recommendation/similar/application";
      } else {
        URLparam = Config.ActivityServiceURL + "/api/activity/application";
      }
    }

    let IsAnonymous = false;

    if (Application_Type === "Normal") {
      ApplicationType = "DEFAULT";
    } else if (Application_Type === "Anonymous") {
      ApplicationType = "ANONYMOUS";
      IsAnonymous = true;
    }

    let Data;
    if (props.MoreLikeThisIsActive) {
      Data = {
        id: props.Data.id,
        isAnonymous: IsAnonymous,
        availability: {
          value: AvailabilityData.value,
          unit: AvailabilityData.unit,
          startDate: AvailabilityData.startDate,
          endDate: AvailabilityData.endDate,
        },
      };
    } else {
      Data = {
        recommendationId: props.Data.id,
        type: ApplicationType,
        availability: {
          value: AvailabilityData.value,
          unit: AvailabilityData.unit,
          startDate: AvailabilityData.startDate,
          endDate: AvailabilityData.endDate,
        },
      };
    }

    let Req = {
      method: "POST",
      baseURL: window._env_.API_URL + URLparam,
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "application/json",
      },
      data: Data,
    };

    axios(Req)
      .then((Res) => {
        console.log(Res);
        props.ClickActivePage();
      })
      .catch((Err) => {
        console.log(Err.response);
      });
  };
  const saveSelectedDate = (DateValue, Type) => {
    let Day = new Date(DateValue).getDate();
    let Month = new Date(DateValue).getMonth() + 1;
    let Year = new Date(DateValue).getFullYear();

    if (Month < 10) {
      Month = "0" + Month;
    }

    if (Day < 10) {
      Day = "0" + Day;
    }

    let FinalDate = Year + "-" + Month + "-" + Day;

    if (Type === "start") {
      setSelectedStartDate(FinalDate);
    } else {
      setSelectedEndDate(FinalDate);
    }
  };
  return (
    <React.Fragment>
      <NavLink hidden to="/communication" id="communication-toggle"></NavLink>
      {ItemDetails ? (
        <div className="jpa-item">
          {ContextMenuIsOpen ? (
            <>
              <div
                className="outline"
                onClick={() => setContextMenuIsOpen(false)}
              ></div>
              <div className="jpa-context-menu">
                <div className="menu-row">
                  <button
                    onClick={() => toggleSave()}
                    id={props.Id + "-save"}
                    className={
                      props.Data.bookmarked
                        ? "bookmark saved-no-animation"
                        : "bookmark"
                    }
                  >
                    <img
                      alt=""
                      src={
                        props.Data.bookmarked ? BookmarkedIcon : BookmarkIcon
                      }
                    />
                    {translateText("save")}
                    {IsSaved ? (
                      <React.Fragment>
                        {window.innerWidth >= 451 ? (
                          <p className="popup-text">
                            {translateText("unsave")}
                          </p>
                        ) : null}
                      </React.Fragment>
                    ) : (
                      <React.Fragment>
                        {window.innerWidth >= 451 ? (
                          <p className="popup-text">{translateText("save")}</p>
                        ) : null}
                      </React.Fragment>
                    )}
                  </button>
                </div>

                <div className="menu-row">
                  {ItemDetails.deleted ||
                  (ItemDetails.recruitmentStatus === "ACCEPTED" &&
                    props.Data.application !== null &&
                    !props.Data.application.acceptedForMe) ||
                  props.Data.reviewer === null ? (
                    <button
                      className="communication-connector disabled-connector"
                      onClick={() => null}
                    ></button>
                  ) : (
                    <button
                      className="communication-connector"
                      onClick={() => toggleChat()}
                    >
                      <img alt="" src={ConnectIcon} />
                      <p className="popup-text">{translateText("connect")}</p>
                    </button>
                  )}
                </div>
                {props.IsApplied ? (
                  <div className="menu-row">
                    <button
                      className={
                        props.AvailabilityModalData
                          ? "communication-connector availability-btn"
                          : "communication-connector availability-btn disabled-availability"
                      }
                      onClick={() => props.ToggleAvailabilityModal()}
                    >
                      <img alt="" src={AvailabilityIconSilver} />
                      <p className="popup-text">
                        {translateText("availability")}
                      </p>
                    </button>
                  </div>
                ) : null}
              </div>
            </>
          ) : null}
          {PopupIsOpen ? (
            <ReasonPopup
              Reasons={Reasons}
              SelectReasonItem={(Reason) => selectReason(Reason)}
              Close={() => setPopupIsOpen(false)}
              LastJPAaction={LastJPAaction}
              LangData={props.LangData}
            />
          ) : null}
          {window.innerWidth <= 450 ? (
            <section className="jpa-head">
              <button
                id={props.Id + "-dislike"}
                onClick={() => toggleDislike()}
                className={
                  props.Data.reactionType === "DISLIKE"
                    ? "rounded overlayed-no-animation"
                    : "rounded"
                }
              >
                <i className="feather-thumbs-down"></i>
                {window.innerWidth >= 451 ? (
                  <p className="popup-text">{translateText("dislike")}</p>
                ) : null}
              </button>
              <button
                id={props.Id + "-like"}
                onClick={() => toggleLike()}
                className={
                  props.Data.reactionType === "LIKE"
                    ? "rounded overlayed-no-animation"
                    : "rounded"
                }
              >
                <i className="feather-thumbs-up"></i>
                {window.innerWidth >= 451 ? (
                  <p className="popup-text">{translateText("like")}</p>
                ) : null}
              </button>

              <button
                className="rounded"
                onClick={() => setContextMenuIsOpen(!ContextMenuIsOpen)}
              >
                <i className="feather-more-vertical"></i>
              </button>
            </section>
          ) : (
            <section className="jpa-head">
              {props.IsApplied ? (
                <button
                  className="communication-connector availability-btn"
                  onClick={() => props.ToggleAvailabilityModal()}
                >
                  <p className="popup-text">{translateText("availability")}</p>
                </button>
              ) : null}

              {ItemDetails.deleted ||
              (ItemDetails.recruitmentStatus === "ACCEPTED" &&
                props.Data.application !== null &&
                !props.Data.application.acceptedForMe) ||
              props.Data.reviewer === null ? (
                <button
                  className="communication-connector disabled-connector"
                  onClick={() => null}
                ></button>
              ) : (
                <button
                  className="communication-connector"
                  onClick={() => toggleChat()}
                >
                  <p className="popup-text">{translateText("chat")}</p>
                </button>
              )}

              <button
                id={props.Id + "-dislike"}
                onClick={() => toggleDislike()}
                className={
                  props.Data.reactionType === "DISLIKE"
                    ? "rounded overlayed-no-animation"
                    : "rounded"
                }
              >
                <i className="feather-thumbs-down"></i>
                {window.innerWidth >= 451 ? (
                  <p className="popup-text">{translateText("dislike")}</p>
                ) : null}
              </button>
              <button
                id={props.Id + "-like"}
                onClick={() => toggleLike()}
                className={
                  props.Data.reactionType === "LIKE"
                    ? "rounded overlayed-no-animation"
                    : "rounded"
                }
              >
                <i className="feather-thumbs-up"></i>
                {window.innerWidth >= 451 ? (
                  <p className="popup-text">{translateText("like")}</p>
                ) : null}
              </button>
              <button
                onClick={() => toggleSave()}
                id={props.Id + "-save"}
                className={
                  props.Data.bookmarked
                    ? "bookmark saved-no-animation"
                    : "bookmark"
                }
              >
                <i className="feather-bookmark"></i>
                <i className="feather-plus"></i>
                {IsSaved ? (
                  <React.Fragment>
                    {window.innerWidth >= 451 ? (
                      <p className="popup-text">{translateText("unsave")}</p>
                    ) : null}
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    {window.innerWidth >= 451 ? (
                      <p className="popup-text">{translateText("save")}</p>
                    ) : null}
                  </React.Fragment>
                )}
              </button>
            </section>
          )}
          <h1 className="jpa-title">
            {shortenTitle(ItemDetails.title)}
            {handleDisplayPopup()}
          </h1>
          <p className="jpa-location">
            {shortenLocation(ItemDetails.workCity ? ItemDetails.workCity : "")}
            {handleDisplayLocationPopup()}
          </p>
          {props.IsApplied && props.ApplicationData.details.length > 0 ? (
            <section className="jpa-actions post-apply-actions">
              {props.ApplicationData.details[1].subStage === "PENDING" ? (
                <React.Fragment>
                  {props.ApplicationData.status === "CANCELLED" ||
                  (ItemDetails.recruitmentStatus === "ACCEPTED" &&
                    !props.Data.application.acceptedForMe) ? (
                    <React.Fragment>
                      <span className="cancel-application disabled-cancel">
                        {translateText("anonymous_apply")}
                      </span>
                      <span className="cancel-application disabled-cancel">
                        {translateText("apply")}
                      </span>
                    </React.Fragment>
                  ) : (
                    <span
                      className="cancel-application"
                      onClick={() => props.ToggleCancel(props.Data)}
                    >
                      {translateText("cancel_application")}
                    </span>
                  )}
                </React.Fragment>
              ) : (
                <React.Fragment>
                  {props.ApplicationData.details[2].subStage ===
                    "INVITE_SENT" && !props.ApplicationData.revealIdentity ? (
                    <React.Fragment>
                      <span
                        className="cancel-application"
                        onClick={() =>
                          props.HandleVerifyInterview(props.Data, "REJECT")
                        }
                      >
                        {translateText("reject_invitation")}
                      </span>
                      <span
                        className="cancel-application accept-invite"
                        onClick={() =>
                          props.HandleVerifyInterview(props.Data, "ACCEPT")
                        }
                      >
                        {translateText("accept_invitiation")}
                      </span>
                    </React.Fragment>
                  ) : (
                    <React.Fragment>
                      {props.ApplicationData.details[2].subStage ===
                      "INVITE_REJECTED" ? (
                        <React.Fragment>
                          <span className="cancel-application disabled-cancel">
                            {translateText("reject_invitation")}
                          </span>
                          <span className="cancel-application disabled-cancel">
                            {translateText("accept_invitiation")}
                          </span>
                        </React.Fragment>
                      ) : (
                        <React.Fragment>
                          {props.ApplicationData.details[2].subStage ===
                          "INVITE_ACCEPTED" ? (
                            <React.Fragment>
                              <span className="cancel-application disabled-cancel">
                                {translateText("reject_invitation")}
                              </span>
                              <span className="cancel-application disabled-cancel">
                                {translateText("accept_invitiation")}
                              </span>
                            </React.Fragment>
                          ) : (
                            <React.Fragment>
                              {props.ApplicationData.details[3].subStage ===
                                "IN_PROGRESS" &&
                              props.ApplicationData.details[3].stage ===
                                "FINAL_DECISION" &&
                              props.ApplicationData.type !== "DEFAULT" &&
                              props.ApplicationData.directFinalDecision &&
                              !props.ApplicationData.revealIdentity ? (
                                <React.Fragment>
                                  <span
                                    className="cancel-application"
                                    onClick={() =>
                                      props.HandleVerifyInterview(
                                        props.Data,
                                        "CANCEL"
                                      )
                                    }
                                  >
                                    {translateText("cancel")}
                                  </span>
                                  <span
                                    className="cancel-application accept-invite"
                                    onClick={() =>
                                      props.HandleVerifyInterview(
                                        props.Data,
                                        "PROCEED"
                                      )
                                    }
                                  >
                                    {translateText("proceed")}
                                  </span>
                                </React.Fragment>
                              ) : (
                                <React.Fragment>
                                  {props.ApplicationData.details[3].subStage ===
                                    "IN_PROGRESS" &&
                                  props.ApplicationData.details[3].stage ===
                                    "FINAL_DECISION" &&
                                  props.ApplicationData.type !== "DEFAULT" &&
                                  props.ApplicationData.directFinalDecision &&
                                  props.ApplicationData.revealIdentity ? (
                                    <React.Fragment>
                                      <span className="cancel-application disabled-cancel">
                                        {translateText("cancel")}
                                      </span>
                                      <span className="cancel-application disabled-cancel">
                                        {translateText("proceed")}
                                      </span>
                                    </React.Fragment>
                                  ) : (
                                    <React.Fragment>
                                      {!HasCoolcown && HasBeenRejected ? (
                                        <React.Fragment>
                                          <span
                                            className="accept-invite"
                                            onClick={() =>
                                              props.ToggleApply(
                                                props.Data,
                                                "Anonymous"
                                              )
                                            }
                                          >
                                            {translateText("anonymous_apply")}
                                          </span>
                                          <span
                                            className="accept-invite"
                                            onClick={() =>
                                              props.ToggleApply(
                                                props.Data,
                                                "Normal"
                                              )
                                            }
                                          >
                                            {translateText("apply")}
                                          </span>
                                        </React.Fragment>
                                      ) : (
                                        <React.Fragment>
                                          {props.ApplicationData
                                            .sendConfirmationReset ? (
                                            <span
                                              className="accept-invite"
                                              onClick={() =>
                                                props.ToggleConfirmResetApplication(
                                                  props.Data
                                                )
                                              }
                                            >
                                              {translateText("confirm_reset")}
                                            </span>
                                          ) : (
                                            <span className="cancel-application disabled-cancel">
                                              {translateText(
                                                "cancel_application"
                                              )}
                                            </span>
                                          )}
                                        </React.Fragment>
                                      )}
                                    </React.Fragment>
                                  )}
                                </React.Fragment>
                              )}
                            </React.Fragment>
                          )}
                        </React.Fragment>
                      )}
                    </React.Fragment>
                  )}
                </React.Fragment>
              )}
              <div className="links-holder">
                {!props.MoreLikeThisIsActive ? (
                  <p onClick={() => props.RequestMoreLikeThis(props.Data)}>
                    {translateText("more_like_this")}
                  </p>
                ) : null}
                <p onClick={() => props.ReqDetails(props.Data)}>
                  {translateText("more_details")}
                </p>
              </div>
            </section>
          ) : (
            <React.Fragment>
              {props.IsAvailable ? (
                <>
                  {AvailabilityDatePickerIsOpen ? (
                    <section className="jpa-actions post-apply-actions">
                      <span
                        className="cancel-application"
                        onClick={() => cancelApplicationRequest()}
                      >
                        {translateText("cancel")}
                      </span>
                      <span
                        className="cancel-application accept-invite"
                        onClick={() => validateAvailabilityValues()}
                      >
                        {translateText("apply")}
                      </span>
                      <div className="links-holder">
                        {!props.MoreLikeThisIsActive ? (
                          <p
                            onClick={() =>
                              props.RequestMoreLikeThis(props.Data)
                            }
                          >
                            {translateText("more_like_this")}
                          </p>
                        ) : null}
                        <p onClick={() => props.ReqDetails(props.Data)}>
                          {translateText("more_details")}
                        </p>
                      </div>
                    </section>
                  ) : (
                    <section className="jpa-actions active-actions">
                      <span
                        onClick={() =>
                          toggleApplication(props.Data, "Anonymous")
                        }
                      >
                        {translateText("anonymous_apply")}
                      </span>
                      <span
                        onClick={() => toggleApplication(props.Data, "Normal")}
                      >
                        {translateText("apply")}
                      </span>
                      <div className="links-holder">
                        {!props.MoreLikeThisIsActive ? (
                          <p
                            onClick={() =>
                              props.RequestMoreLikeThis(props.Data)
                            }
                          >
                            {translateText("more_like_this")}
                          </p>
                        ) : null}
                        <p onClick={() => props.ReqDetails(props.Data)}>
                          {translateText("more_details")}
                        </p>
                      </div>
                    </section>
                  )}
                </>
              ) : (
                <section className="jpa-actions post-apply-actions">
                  <span className="cancel-application disabled-cancel">
                    {translateText("anonymous_apply")}
                  </span>
                  <span className="cancel-application disabled-cancel">
                    {translateText("apply")}
                  </span>
                  <div className="links-holder">
                    {!props.MoreLikeThisIsActive ? (
                      <p onClick={() => props.RequestMoreLikeThis(props.Data)}>
                        {translateText("more_like_this")}
                      </p>
                    ) : null}
                    <p onClick={() => props.ReqDetails(props.Data)}>
                      {translateText("more_details")}
                    </p>
                  </div>
                </section>
              )}
            </React.Fragment>
          )}
          {props.IsApplied ? (
            <React.Fragment>
              {ItemDetails.deleted ||
              (ItemDetails.recruitmentStatus === "ACCEPTED" &&
                !props.Data.application.acceptedForMe) ? (
                <Collapsible
                  trigger={
                    <section className="info-trigger" id={props.Id}>
                      <p
                        className={
                          props.ApplicationData.status === "CANCELLED"
                            ? "cancelled-label"
                            : ""
                        }
                      >
                        {translateText("not_available")}
                      </p>
                      <i
                        className={
                          props.ApplicationData.status === "CANCELLED"
                            ? "feather-chevron-down cancelled-icon"
                            : "feather-chevron-down"
                        }
                        id={props.Id + "-icon"}
                      ></i>
                    </section>
                  }
                  transitionTime={200}
                  onOpen={() => handleOpen()}
                  onOpening={() => props.UpdateOtherOpenStates()}
                  onClose={() => handleClose()}
                >
                  <div className="more-info cancelled-info">
                    <p className="not-available-text">
                      {translateText("vacancy_no_longer_available")}
                    </p>
                  </div>
                </Collapsible>
              ) : (
                <Collapsible
                  trigger={
                    <section className="info-trigger" id={props.Id}>
                      <p
                        className={
                          props.ApplicationData.status === "CANCELLED"
                            ? "cancelled-label"
                            : ""
                        }
                      >
                        {showStatus(props.ApplicationData) +
                          " " +
                          showApplicationType(props.ApplicationData)}
                      </p>
                      <i
                        className={
                          props.ApplicationData.status === "CANCELLED"
                            ? "feather-chevron-down cancelled-icon"
                            : "feather-chevron-down"
                        }
                        id={props.Id + "-icon"}
                      ></i>
                    </section>
                  }
                  transitionTime={200}
                  onOpen={() => handleOpen()}
                  onOpening={() => props.UpdateOtherOpenStates()}
                  onClose={() => handleClose()}
                >
                  {props.ApplicationData.status === "CANCELLED" ? (
                    <div className="more-info cancelled-info">
                      <section className="cancellation-info">
                        <span>
                          <i className="cancellation-icon feather-clock"></i>
                        </span>
                        <span>
                          <p>
                            {translateText("cancelled_on") + " "}
                            {returnCancellationDate(props.ApplicationData)}
                          </p>
                          <p>
                            {translateText("time_to_reapply") + " "}
                            {displayReapplyDate(props.ApplicationData)}
                          </p>
                        </span>
                      </section>
                    </div>
                  ) : (
                    <div className="more-info">
                      <span className="big-hr-line"></span>
                      <span className="big-vr-line is-mobile"></span>
                      <section className="progress-item">
                        {!props.ApplicationData.revealIdentity ? (
                          <React.Fragment>
                            {props.ApplicationData.details[0].subStage ===
                              "DONE" &&
                            props.ApplicationData.details[1].subStage ===
                              "PENDING" ? (
                              <span className="progress-item-icon progress-item-icon-active">
                                <img alt="" src={Anonymous} />
                              </span>
                            ) : (
                              <span className="progress-item-icon">
                                <img alt="" src={AnonymousWhite} />
                              </span>
                            )}
                          </React.Fragment>
                        ) : (
                          <React.Fragment>
                            {props.ApplicationData.details[0].subStage ===
                              "DONE" &&
                            props.ApplicationData.details[1].subStage ===
                              "PENDING" &&
                            props.ApplicationData.details[2].subStage ===
                              "PENDING" ? (
                              <span className="progress-item-icon progress-item-icon-active">
                                {props.UserInfo.imageThumbnailUrl === null ? (
                                  <p>
                                    {props.UserInfo.firstName
                                      .slice(0, 1)
                                      .toUpperCase() +
                                      props.UserInfo.lastName
                                        .slice(0, 1)
                                        .toUpperCase()}
                                  </p>
                                ) : (
                                  <img
                                    className="reviewer-image"
                                    alt=""
                                    src={props.UserInfo.imageThumbnailUrl}
                                  />
                                )}
                              </span>
                            ) : (
                              <span className="progress-item-icon">
                                {props.UserInfo.imageThumbnailUrl === null ? (
                                  <p>
                                    {props.UserInfo.firstName
                                      .slice(0, 1)
                                      .toUpperCase() +
                                      props.UserInfo.lastName
                                        .slice(0, 1)
                                        .toUpperCase()}
                                  </p>
                                ) : (
                                  <img
                                    className="reviewer-image"
                                    alt=""
                                    src={props.UserInfo.imageThumbnailUrl}
                                  />
                                )}
                              </span>
                            )}
                          </React.Fragment>
                        )}
                        <span className="vr-line"></span>
                        <span className="item-label-holder">
                          {props.ApplicationData.details[0].subStage ===
                            "DONE" &&
                          props.ApplicationData.details[1].subStage ===
                            "PENDING" ? (
                            <p className="item-label item-label-active">
                              {translateText("jpa_status_applied")}
                            </p>
                          ) : (
                            <p className="item-label">
                              {translateText("jpa_status_applied")}
                            </p>
                          )}
                          <p className="apply-date">
                            {formatDate(
                              new Date(
                                props.ApplicationData.details[0].date
                              ).getTime()
                            )}
                          </p>
                        </span>
                      </section>
                      <section className="progress-item">
                        {props.ApplicationData.details[1].subStage ===
                        "IN_PROGRESS" ? (
                          <span className="progress-item-icon progress-item-icon-active">
                            <React.Fragment>
                              {props.ApplicationData.details[1].subStage ===
                              "IN_PROGRESS" ? (
                                <React.Fragment>
                                  {props.Data.reviewer.imageThumbnailUrl ===
                                  null ? (
                                    <p className="reviewer">
                                      {props.Data.reviewer.firstName
                                        .slice(0, 1)
                                        .toUpperCase() +
                                        props.Data.reviewer.lastName
                                          .slice(0, 1)
                                          .toUpperCase()}
                                    </p>
                                  ) : (
                                    <img
                                      className="reviewer-image"
                                      alt=""
                                      src={
                                        props.Data.reviewer.imageThumbnailUrl
                                      }
                                    />
                                  )}
                                </React.Fragment>
                              ) : (
                                <span className="progress-item-icon">
                                  <img alt="" src={EyeIcon} />
                                </span>
                              )}
                            </React.Fragment>
                            <React.Fragment>
                              {props.Data.reviewer === null ? null : (
                                <p className="reviewer-name">
                                  {props.Data.reviewer.firstName +
                                    " " +
                                    props.Data.reviewer.lastName}
                                </p>
                              )}
                            </React.Fragment>
                          </span>
                        ) : (
                          <React.Fragment>
                            {props.ApplicationData.details[1].subStage ===
                            "DONE" ? (
                              <span className="progress-item-icon">
                                <React.Fragment>
                                  {props.Data.reviewer.imageThumbnailUrl ===
                                  null ? (
                                    <p className="reviewer">
                                      {props.Data.reviewer.firstName
                                        .slice(0, 1)
                                        .toUpperCase() +
                                        props.Data.reviewer.lastName
                                          .slice(0, 1)
                                          .toUpperCase()}
                                    </p>
                                  ) : (
                                    <img
                                      className="reviewer-image"
                                      alt=""
                                      src={
                                        props.Data.reviewer.imageThumbnailUrl
                                      }
                                    />
                                  )}
                                </React.Fragment>
                                {props.Data.reviewer === null ? null : (
                                  <p className="reviewer-name-popup">
                                    {props.Data.reviewer.firstName +
                                      " " +
                                      props.Data.reviewer.lastName}
                                  </p>
                                )}
                              </span>
                            ) : (
                              <span className="progress-item-icon">
                                {props.Data.reviewer === null ? (
                                  <img alt="" src={EyeIcon} />
                                ) : (
                                  <p className="reviewer">
                                    <React.Fragment>
                                      {props.Data.reviewer.imageThumbnailUrl ===
                                      null ? (
                                        <p className="reviewer">
                                          {props.Data.reviewer.firstName
                                            .slice(0, 1)
                                            .toUpperCase() +
                                            props.Data.reviewer.lastName
                                              .slice(0, 1)
                                              .toUpperCase()}
                                        </p>
                                      ) : (
                                        <img
                                          className="reviewer-image"
                                          alt=""
                                          src={
                                            props.Data.reviewer
                                              .imageThumbnailUrl
                                          }
                                        />
                                      )}
                                    </React.Fragment>
                                    <React.Fragment>
                                      {props.Data.reviewer === null ? null : (
                                        <p className="reviewer-name-popup">
                                          {props.Data.reviewer.firstName +
                                            " " +
                                            props.Data.reviewer.lastName}
                                        </p>
                                      )}
                                    </React.Fragment>
                                  </p>
                                )}
                              </span>
                            )}
                          </React.Fragment>
                        )}
                        <span className="vr-line"></span>
                        <span className="item-label-holder">
                          {props.ApplicationData.details[1].subStage ===
                          "DONE" ? (
                            <p className="item-label">
                              {translateText("reviewed")}
                            </p>
                          ) : (
                            <React.Fragment>
                              {props.ApplicationData.details[1].subStage ===
                              "IN_PROGRESS" ? (
                                <p className="item-label item-label-active">
                                  {translateText(
                                    "jpa_status_action_stage_review"
                                  )}
                                </p>
                              ) : (
                                <p className="item-label">
                                  {translateText(
                                    "jpa_status_action_stage_review"
                                  )}
                                </p>
                              )}
                            </React.Fragment>
                          )}
                          {props.ApplicationData.details[1].subStage ===
                          "PENDING" ? (
                            <p className="apply-date">
                              {translateText("pending")}
                            </p>
                          ) : (
                            <p className="apply-date">
                              {props.ApplicationData.details[1].subStage ===
                              "DONE"
                                ? translateText("done")
                                : translateText("in_progress") + " "}
                            </p>
                          )}
                        </span>
                      </section>
                      <section className="progress-item">
                        {(props.ApplicationData.details[2].subStage ===
                          "IN_PROGRESS" &&
                          props.ApplicationData.details[3].subStage !==
                            "DONE") ||
                        (props.ApplicationData.details[2].subStage ===
                          "INVITE_SENT" &&
                          props.Data.application.details[0].subStage ===
                            "DONE" &&
                          props.Data.application.details[1].subStage ===
                            "DONE" &&
                          props.Data.application.details[2].subStage ===
                            "INVITE_SENT" &&
                          props.Data.application.details[2].stage ===
                            "INTERVIEW" &&
                          props.Data.application.details[3].subStage ===
                            "PENDING") ||
                        props.ApplicationData.details[2].subStage ===
                          "INVITE_REJECTED" ||
                        (props.ApplicationData.details[2].subStage ===
                          "INVITE_ACCEPTED" &&
                          props.ApplicationData.details[3].subStage !==
                            "IN_PROGRESS") ? (
                          <span className="progress-item-icon progress-item-icon-active">
                            <img alt="" src={MessageWhite} />
                          </span>
                        ) : (
                          <span className="progress-item-icon">
                            <img alt="" src={MessageIcon} />
                          </span>
                        )}
                        <span className="vr-line"></span>
                        <span className="item-label-holder">
                          {props.ApplicationData.details[2].subStage !==
                          "PENDING" ? (
                            <React.Fragment>
                              {props.ApplicationData.details[2].subStage ===
                              "SKIPPED" ? (
                                <p className="item-label">
                                  {translateText("jpa_status_action_interview")}
                                </p>
                              ) : (
                                <React.Fragment>
                                  {props.ApplicationData.details[2].subStage ===
                                  "IN_PROGRESS" ? (
                                    <p className="item-label">
                                      {translateText(
                                        "jpa_status_action_interview"
                                      )}
                                    </p>
                                  ) : (
                                    <React.Fragment>
                                      {props.Data.application.details[0]
                                        .subStage === "DONE" &&
                                      props.Data.application.details[1]
                                        .subStage === "DONE" &&
                                      props.Data.application.details[2]
                                        .subStage === "INVITE_SENT" &&
                                      props.Data.application.details[2]
                                        .stage === "INTERVIEW" &&
                                      props.Data.application.details[3]
                                        .subStage === "PENDING" ? (
                                        <p className="item-label item-label-active">
                                          {translateText(
                                            "jpa_status_action_interview"
                                          )}
                                        </p>
                                      ) : (
                                        <React.Fragment>
                                          {props.ApplicationData.details[2]
                                            .subStage === "INVITE_REJECTED" ||
                                          props.ApplicationData.details[2]
                                            .subStage === "INVITE_ACCEPTED" ? (
                                            <p className="item-label item-label-active">
                                              {translateText(
                                                "jpa_status_action_interview"
                                              )}
                                            </p>
                                          ) : (
                                            <p className="item-label">
                                              {props.ApplicationData.details[0]
                                                .subStage === "DONE" &&
                                              props.ApplicationData.details[1]
                                                .subStage === "DONE" &&
                                              props.ApplicationData.details[2]
                                                .subStage === "CANCELLED" &&
                                              props.ApplicationData.details[3]
                                                .stage === "FINAL_DECISION" &&
                                              props.ApplicationData.details[3]
                                                .subStage === "CANCELLED"
                                                ? translateText(
                                                    "jpa_status_action_interview"
                                                  )
                                                : translateText("interviewed")}
                                            </p>
                                          )}
                                        </React.Fragment>
                                      )}
                                    </React.Fragment>
                                  )}
                                </React.Fragment>
                              )}
                            </React.Fragment>
                          ) : (
                            <p className="item-label">
                              {translateText("jpa_status_action_interview")}
                            </p>
                          )}
                          {props.ApplicationData.details[2].subStage ===
                          "DONE" ? (
                            <React.Fragment>
                              {props.ApplicationData.details[2].subStage ===
                              "SKIPPED" ? (
                                <p className="apply-date">
                                  {translateText("skipped")}
                                </p>
                              ) : (
                                <p className="apply-date">
                                  {translateText("done")}
                                </p>
                              )}
                            </React.Fragment>
                          ) : (
                            <React.Fragment>
                              {props.ApplicationData.details[2].subStage ===
                              "IN_PROGRESS" ? (
                                <p className="apply-date">
                                  {translateText("in_progress")}
                                </p>
                              ) : (
                                <React.Fragment>
                                  {props.ApplicationData.details[2].subStage ===
                                  "INVITE_REJECTED" ? (
                                    <p className="apply-date">
                                      {translateText("jpa_status_cancelled")}
                                    </p>
                                  ) : (
                                    <React.Fragment>
                                      {props.ApplicationData.details[2]
                                        .subStage === "SKIPPED" ? (
                                        <p className="apply-date">
                                          {translateText("skipped")}
                                        </p>
                                      ) : (
                                        <React.Fragment>
                                          {props.ApplicationData.details[3]
                                            .subStage === "IN_PROGRESS" ? (
                                            <p className="apply-date">
                                              {translateText("skipped")}
                                            </p>
                                          ) : (
                                            <React.Fragment>
                                              {props.ApplicationData.details[3]
                                                .subStage === "PENDING" &&
                                              props.ApplicationData.details[2]
                                                .subStage === "INVITE_SENT" ? (
                                                <p className="apply-date">
                                                  {translateText("in_progress")}
                                                </p>
                                              ) : (
                                                <p className="apply-date">
                                                  {props.ApplicationData
                                                    .details[0].subStage ===
                                                    "DONE" &&
                                                  props.ApplicationData
                                                    .details[1].subStage ===
                                                    "DONE" &&
                                                  props.ApplicationData
                                                    .details[2].subStage ===
                                                    "CANCELLED" &&
                                                  props.ApplicationData
                                                    .details[3].stage ===
                                                    "FINAL_DECISION" &&
                                                  props.ApplicationData
                                                    .details[3].subStage ===
                                                    "CANCELLED" ? (
                                                    "You cancelled"
                                                  ) : (
                                                    <>
                                                      {props.Data.application
                                                        .details[0].subStage ===
                                                        "DONE" &&
                                                      props.Data.application
                                                        .details[1].subStage ===
                                                        "DONE" &&
                                                      props.Data.application
                                                        .details[2].subStage ===
                                                        "INVITE_SENT" &&
                                                      props.Data.application
                                                        .details[2].stage ===
                                                        "INTERVIEW" &&
                                                      props.Data.application
                                                        .details[3].subStage ===
                                                        "DONE"
                                                        ? "Done"
                                                        : "Pending"}
                                                    </>
                                                  )}
                                                </p>
                                              )}
                                            </React.Fragment>
                                          )}
                                        </React.Fragment>
                                      )}
                                    </React.Fragment>
                                  )}
                                </React.Fragment>
                              )}
                            </React.Fragment>
                          )}
                        </span>
                      </section>
                      <section className="progress-item">
                        <span
                          className={
                            props.ApplicationData.details[3].subStage ===
                              "DONE" ||
                            props.ApplicationData.details[3].subStage ===
                              "IN_PROGRESS" ||
                            (props.ApplicationData.details[3].subStage ===
                              "CANCELLED" &&
                              props.ApplicationData.details[0].subStage ===
                                "DONE" &&
                              props.ApplicationData.details[1].subStage ===
                                "DONE" &&
                              props.ApplicationData.details[2].subStage !==
                                "CANCELLED" &&
                              props.ApplicationData.details[3].stage ===
                                "FINAL_DECISION") ||
                            (props.ApplicationData.details[0].subStage ===
                              "DONE" &&
                              props.ApplicationData.details[1].subStage ===
                                "DONE" &&
                              props.ApplicationData.details[2].subStage !==
                                "SKIPPED" &&
                              props.ApplicationData.details[3].stage ===
                                "FINAL_DECISION" &&
                              props.ApplicationData.details[3].subStage !==
                                "CANCELLED" &&
                              props.ApplicationData.details[3].subStage !==
                                "PENDING") ||
                            (props.ApplicationData.details[0].subStage ===
                              "DONE" &&
                              props.ApplicationData.details[1].subStage ===
                                "DONE" &&
                              props.ApplicationData.details[2].subStage ===
                                "CANCELLED" &&
                              props.ApplicationData.details[3].stage ===
                                "FINAL_DECISION" &&
                              props.ApplicationData.details[3].subStage ===
                                "CANCELLED")
                              ? "progress-item-icon progress-item-icon-active"
                              : "progress-item-icon"
                          }
                        >
                          {props.ApplicationData.details[3].subStage ===
                          "DONE" ? (
                            <React.Fragment>
                              {props.ApplicationData.details[3].stage ===
                              "ACCEPTED" ? (
                                <img alt="" src={SmileWhite} />
                              ) : (
                                <img alt="" src={Frown} />
                              )}
                            </React.Fragment>
                          ) : (
                            <React.Fragment>
                              {props.ApplicationData.details[3].subStage ===
                                "IN_PROGRESS" ||
                              props.ApplicationData.details[3].subStage ===
                                "CANCELLED" ? (
                                <React.Fragment>
                                  {props.ApplicationData.details[3].subStage ===
                                  "CANCELLED" ? (
                                    <React.Fragment>
                                      {(props.ApplicationData.details[0]
                                        .subStage === "DONE" &&
                                        props.ApplicationData.details[1]
                                          .subStage === "DONE" &&
                                        props.ApplicationData.details[2]
                                          .subStage === "SKIPPED" &&
                                        props.ApplicationData.details[3]
                                          .stage === "FINAL_DECISION" &&
                                        props.ApplicationData.details[3]
                                          .subStage === "CANCELLED") ||
                                      (props.ApplicationData.details[0]
                                        .subStage === "DONE" &&
                                        props.ApplicationData.details[1]
                                          .subStage === "DONE" &&
                                        props.ApplicationData.details[2]
                                          .subStage === "CANCELLED" &&
                                        props.ApplicationData.details[3]
                                          .stage === "FINAL_DECISION" &&
                                        props.ApplicationData.details[3]
                                          .subStage === "CANCELLED") ? (
                                        <img alt="frown" src={Meh} />
                                      ) : (
                                        <img
                                          alt=""
                                          src={
                                            (props.ApplicationData.details[3]
                                              .subStage === "CANCELLED" &&
                                              props.ApplicationData.details[0]
                                                .subStage === "DONE" &&
                                              props.ApplicationData.details[1]
                                                .subStage === "DONE" &&
                                              props.ApplicationData.details[2]
                                                .subStage !== "CANCELLED" &&
                                              props.ApplicationData.details[3]
                                                .stage === "FINAL_DECISION" &&
                                              props.ApplicationData.details[3]
                                                .subStage !== "CANCELLED") ||
                                            (props.ApplicationData.details[0]
                                              .subStage === "DONE" &&
                                              props.ApplicationData.details[1]
                                                .subStage === "DONE" &&
                                              props.ApplicationData.details[2]
                                                .subStage === "SKIPPED" &&
                                              props.ApplicationData.details[3]
                                                .stage === "FINAL_DECISION" &&
                                              props.ApplicationData.details[3]
                                                .subStage === "CANCELLED")
                                              ? Frown
                                              : Smile
                                          }
                                        />
                                      )}
                                    </React.Fragment>
                                  ) : (
                                    <img alt="" src={Meh} />
                                  )}
                                </React.Fragment>
                              ) : (
                                <img alt="" src={MehSilver} />
                              )}
                            </React.Fragment>
                          )}
                        </span>
                        <span className="vr-line"></span>
                        <span className="item-label-holder">
                          {props.ApplicationData.details[3].subStage ===
                          "DONE" ? (
                            <React.Fragment>
                              {props.ApplicationData.details[3].stage ===
                              "ACCEPTED" ? (
                                <p className="item-label item-label-active">
                                  {translateText("jpa_status_accepted")}
                                </p>
                              ) : (
                                <p className="item-label item-label-active">
                                  {translateText("jpa_status_not_accepted")}
                                </p>
                              )}
                            </React.Fragment>
                          ) : (
                            <React.Fragment>
                              {props.ApplicationData.details[3].subStage ===
                              "IN_PROGRESS" ? (
                                <p className="item-label item-label-active">
                                  {translateText(
                                    "jpa_action_stage_final_decision"
                                  )}
                                </p>
                              ) : (
                                <React.Fragment>
                                  {(props.ApplicationData.details[0]
                                    .subStage === "DONE" &&
                                    props.ApplicationData.details[1]
                                      .subStage === "DONE" &&
                                    props.ApplicationData.details[2]
                                      .subStage === "SKIPPED" &&
                                    props.ApplicationData.details[3].stage ===
                                      "FINAL_DECISION" &&
                                    props.ApplicationData.details[3]
                                      .subStage === "CANCELLED") ||
                                  (props.ApplicationData.details[0].subStage ===
                                    "DONE" &&
                                    props.ApplicationData.details[1]
                                      .subStage === "DONE" &&
                                    props.ApplicationData.details[2]
                                      .subStage === "CANCELLED" &&
                                    props.ApplicationData.details[3].stage ===
                                      "FINAL_DECISION" &&
                                    props.ApplicationData.details[3]
                                      .subStage === "CANCELLED") ? (
                                    <p className="item-label">
                                      {translateText("jpa_status_cancelled")}
                                    </p>
                                  ) : (
                                    <p className="item-label">
                                      {translateText(
                                        "jpa_action_stage_final_decision"
                                      )}
                                    </p>
                                  )}
                                </React.Fragment>
                              )}
                            </React.Fragment>
                          )}
                          {props.ApplicationData.details[3].subStage ===
                            "DONE" ||
                          (props.ApplicationData.details[0].subStage ===
                            "DONE" &&
                            props.ApplicationData.details[1].subStage ===
                              "DONE" &&
                            props.ApplicationData.details[2].subStage ===
                              "CANCELLED" &&
                            props.ApplicationData.details[3].stage ===
                              "FINAL_DECISION" &&
                            props.ApplicationData.details[3].subStage ===
                              "CANCELLED") ? (
                            <React.Fragment>
                              {
                                <p className="apply-date">
                                  {formatDate(
                                    new Date(
                                      props.ApplicationData.details[3].date
                                    ).getTime()
                                  )}
                                </p>
                              }
                            </React.Fragment>
                          ) : (
                            <React.Fragment>
                              {props.ApplicationData.details[3].subStage ===
                              "IN_PROGRESS" ? (
                                <p className="apply-date">
                                  {translateText("in_progress")}
                                </p>
                              ) : (
                                <React.Fragment>
                                  {props.ApplicationData.details[3].subStage ===
                                  "CANCELLED" ? (
                                    <p className="apply-date">
                                      {translateText(
                                        "jpa_status_stage_you_cancelled"
                                      )}
                                    </p>
                                  ) : (
                                    <p className="apply-date">
                                      {translateText("pending")}
                                    </p>
                                  )}
                                </React.Fragment>
                              )}
                            </React.Fragment>
                          )}
                        </span>
                      </section>
                    </div>
                  )}
                </Collapsible>
              )}
            </React.Fragment>
          ) : (
            <React.Fragment>
              {!props.IsAvailable ? (
                <Collapsible
                  trigger={
                    <section className="info-trigger" id={props.Id}>
                      <p className="">{translateText("not_available")}</p>
                      <i
                        className="feather-chevron-down"
                        id={props.Id + "-icon"}
                      ></i>
                    </section>
                  }
                  transitionTime={200}
                  onOpen={() => handleOpen()}
                  onOpening={() => props.UpdateOtherOpenStates()}
                  onClose={() => handleClose()}
                >
                  <div className="more-info cancelled-info">
                    <p className="not-available-text">
                      {translateText("vacancy_no_longer_available")}
                    </p>
                  </div>
                </Collapsible>
              ) : (
                <>
                  {AvailabilityDatePickerIsOpen ? (
                    <Collapsible
                      trigger={
                        <section className="info-trigger" id={props.Id}>
                          <p className="">
                            {translateText("availability_information")}
                          </p>
                          <i
                            className="feather-chevron-down"
                            id={props.Id + "-icon"}
                          ></i>
                        </section>
                      }
                      className="collapse-av"
                      transitionTime={200}
                      onOpen={() => handleOpenCollapsible()}
                      onOpening={() => props.UpdateOtherOpenStates()}
                      onClose={() => handleCloseCollapsible()}
                    >
                      <>
                        <div className="empty-space"></div>
                        <div
                          className={
                            AvailabilityCollapsibleIsOpen
                              ? "more-info avalability-space"
                              : "more-info"
                          }
                        >
                          {AvailabilityCollapsibleIsOpen ? (
                            <AvalilabilityDatepicker
                              LangData={props.LangData}
                              SaveStartDate={(Date) =>
                                saveSelectedDate(Date, "start")
                              }
                              SaveEndDate={(Date) =>
                                saveSelectedDate(Date, "end")
                              }
                            />
                          ) : null}
                        </div>
                      </>
                    </Collapsible>
                  ) : null}
                </>
              )}
            </React.Fragment>
          )}
        </div>
      ) : null}
    </React.Fragment>
  );
};

export default JPAItem;
